import React, { useRef, useEffect, useState, useCallback } from 'react';
import ReactDOM from 'react-dom';
import mapboxgl from 'mapbox-gl/dist/mapbox-gl-csp';
import MapboxWorker from 'worker-loader!mapbox-gl/dist/mapbox-gl-csp-worker';
import HomeIcon from '@material-ui/icons/Home';
import circle from '@turf/circle';
import BasicTable from './BasicTable';
import { theme } from '../theme'
import { ThemeProvider } from '@material-ui/core/styles'
import { Paper, Typography, Box } from '@material-ui/core';

mapboxgl.workerClass = MapboxWorker;
mapboxgl.accessToken = 'pk.eyJ1IjoiaG91c2VjODQiLCJhIjoiY2tsc2t3N3I4MDN4MDJubjgxYjNmODE5ZyJ9.BYgTwOrkMw3hEs9ypeLs8g';

const MapBox = ({ lng, setLng, lat, setLat, zoom, setZoom, bounds, setBounds, data, setData, setClicked, poly, crimes, schools, toggleFly, mapStyle }) => {

    const mapContainer = useRef();
    const [map, setMap] = useState(null);
    const [styleChange, setStyleChange] = useState(false);
    const [sourceChange, setSourceChange] = useState(false);

    useEffect(() => {
        if (mapStyle != null && map != null && data != null) {
            map.setStyle('mapbox://styles/housec84/' + mapStyle.style);
        }
    }, [mapStyle]);


    const emptySourceGeoJson = {
        'type': 'geojson',
        'data': {
            'type': 'FeatureCollection',
            'features': []
        }
    };

    //pretty naff, do this better...
    const emptySource = {
        'type': 'FeatureCollection',
        'features': []
    };



    useEffect(() => {
        if (map != null && map.getSource('plotPoly') != null) {
            if (poly == null) {
                //remove source.
                map.getSource('plotPoly').setData(emptySource);
            }
            else {
                //overwrite source.
                let geojson = {
                    'type': 'FeatureCollection',
                    'features': []
                };
                let pol = {
                    'type': 'Feature',
                    'geometry': JSON.parse(poly),
                    'properties': {
                        'id': String(new Date().getTime())
                    }
                };
                geojson.features.push(pol);
                map.getSource('plotPoly').setData(geojson);
            }
        }
    }, [poly, map, sourceChange]);

    useEffect(() => {
        if (map != null && map.getSource('crimes') != null) {
            if (poly == null) {
                //remove source.

                map.getSource('crimes').setData(emptySource);
            }
            else {
                //overwrite source.
                let geojson = {
                    'type': 'FeatureCollection',
                    'features': []
                };
                crimes.forEach(i => {
                    let pol = {
                        'type': 'Feature',
                        'geometry': {
                            "coordinates": [i.location.longitude, i.location.latitude],
                            "type": "Point"
                        },
                        'properties': {
                            'id': i.id,
                            'location': i.locationDescription,
                            'crimetypes': i.types
                        }
                    };

                    geojson.features.push(pol);
                });


                map.getSource('crimes').setData(geojson);
            }
        }
    }, [crimes, map, sourceChange]);

    useEffect(() => {
        if (map != null && map.getSource('schools') != null) {
            if (poly == null) {
                //remove source.
                map.getSource('schools').setData(emptySource);
                map.getSource('schoolCatchments').setData(emptySource);
            }
            else {
                //overwrite source.
                let geojson = {
                    'type': 'FeatureCollection',
                    'features': []
                };

                let geojsonCatchments = {
                    'type': 'FeatureCollection',
                    'features': []
                };
                schools.forEach(i => {
                    let center = [i.location.longitude, i.location.latitude];
                    let radius = i.catchmentMetresMed / 1000;
                    let options = { steps: 120, units: 'kilometers', properties: { id: i.schoolId } }
                    let circlePoly = circle(center, radius, options);
                    //let circleFeature = {
                    //    'type': 'Feature',
                    //    circlePoly,
                    //    //'geometry': {
                    //    //    "coordinates": circlePoly,
                    //    //    "type": "Polygon"
                    //    //},
                    //    'properties': {
                    //        'id':,
                    //    }
                    //};

                    let circleFeature = circlePoly;
                    let pointFeature = {
                        'type': 'Feature',
                        'geometry': {
                            "coordinates": [i.location.longitude, i.location.latitude],
                            "type": "Point"
                        },
                        'properties': {
                            'id': i.schoolId,
                            'type': i.schoolType,
                            'offsted': i.ofstedRatingString,
                            'capcity': i.percentCapacity,
                            'size': i.schoolSize,
                            'name': i.schoolName,
                            'sex': i.sex,
                            'denomination': i.denomination,
                            'structure': i.structure
                        }
                    };

                    circlePoly['id'] = i.schoolId;
                    pointFeature['id'] = i.schoolId;

                    geojson.features.push(pointFeature);
                    geojsonCatchments.features.push(circleFeature);

                });

                map.getSource('schools').setData(geojson);
                map.getSource('schoolCatchments').setData(geojsonCatchments);
            }
        }
    }, [schools, map, sourceChange]);

    useEffect(() => {
        if (map != null && toggleFly != null && toggleFly.loc != null) {
            map.flyTo({
                padding: {
                    left: toggleFly.left,
                    right: toggleFly.right
                },
                speed: toggleFly.loc.zoom == null ? 1 : 1.5,
                zoom: toggleFly.loc.zoom == null ? 16 : toggleFly.loc.zoom,
                center: [toggleFly.loc.longitude, toggleFly.loc.latitude]
            });
        }
    }, [toggleFly, map]);

    useEffect(() => {
        if (data != null) {
            AddToLayer(map, data.data);
        }
    }, [data, map, styleChange])

    const AddLayers = (mapLocal) => {
        mapLocal.addLayer({
            'id': 'detailLayer',
            'type': 'symbol',
            'source': 'mainData',
            'layout': {
                'icon-image': '3dhouse1',
                'icon-size': 0.7,
                'icon-allow-overlap': true,
                'text-field': ['get', 'label'],
                'text-font': [
                    'Open Sans Semibold',
                    'Arial Unicode MS Bold'
                ],
                'text-offset': [0, 1.25],
                'text-anchor': 'top'
            }
        });

        mapLocal.addLayer({
            'id': 'countsLayer',
            'type': 'symbol',
            'source': 'mainData',
            'layout': {
                'icon-image': 'simplehouse',
                'icon-size': 0.3,
                'icon-allow-overlap': true,
                'text-field': ['get', 'label'],
                'text-font': [
                    'Open Sans Semibold',
                    'Arial Unicode MS Bold'
                ],
                'text-offset': [0, 1.25],
                'text-anchor': 'top'
            },
            "paint": {
                "text-color": mapStyle.dark == false ? "#000000" : "#ffffff"
            }
        });
        //crimes
        mapLocal.addLayer({
            'id': 'crimesLayer',
            'type': 'symbol',
            'source': 'crimes',
            'layout': {
                'icon-image': 'police',
                'icon-size': 0.3,
                'icon-allow-overlap': true,
            }
        });

        mapLocal.addLayer({
            'id': 'schoolsLayer',
            'type': 'symbol',
            'source': 'schools',
            'layout': {
                'icon-image': 'school',
                'icon-size': 0.3,
                'icon-allow-overlap': true,
            }
        });

        //schoolCatchments
        mapLocal.addLayer({
            'id': 'schoolCatchmentsLayer',
            'type': 'fill',
            'source': 'schoolCatchments', // reference the data source
            'layout': {},
            'paint': {
                'fill-color': '#004080', // blue color fill
                //'fill-opacity': 0.05,
                //'visibility':
                //    ['case',
                //        ['==', ['feature-state', 'vis'], null], 'none', 'visible'
                //    ],
                'fill-opacity':
                    ['case',
                        ['==', ['feature-state', 'vis'], null], 0, 0.5
                    ],
                'fill-outline-color': '#000000'
            }
        });

        mapLocal.addLayer({
            'id': 'plotLayer',
            'type': 'fill',
            'source': 'plotPoly', // reference the data source
            'layout': {},
            'paint': {
                'fill-color': '#0080ff', // blue color fill
                'fill-opacity': 0.2
            }
        });
        // Add a black outline around the polygon.
        mapLocal.addLayer({
            'id': 'plotOutline',
            'type': 'line',
            'source': 'plotPoly',
            'layout': {},
            'paint': {
                'line-color': '#000',
                'line-width': 3
            }
        });
    }

    const AddSources = (mapLocal, data) => {

        mapLocal.addSource('mainData', data);
        mapLocal.addSource('plotPoly', emptySourceGeoJson);
        mapLocal.addSource('crimes', emptySourceGeoJson);
        mapLocal.addSource('schools', emptySourceGeoJson);
        mapLocal.addSource('schoolCatchments', emptySourceGeoJson);
        setSourceChange(a => !a);
    }

    const AddToLayer = (mapLocal, data) => {

        if (mapLocal != null && data != null) {

            if (typeof mapLocal.getSource('mainData') === 'undefined') {
                AddSources(mapLocal, data);
            }

            if (typeof mapLocal.getLayer('detailLayer') === 'undefined') {
                //initial setup - not the best place to do this really...
                AddLayers(mapLocal);
            }
            else {
                //update data.
                mapLocal.getSource('mainData').setData(data.data);
            }

            if (data.data && data.data.features[0] && data.data.features[0].properties.count) {
                //aggregated
                map.setLayoutProperty(
                    'countsLayer',
                    'visibility',
                    'visible');
                map.setLayoutProperty(
                    'detailLayer',
                    'visibility',
                    'none');

            } else {
                //detail
                map.setLayoutProperty(
                    'countsLayer',
                    'visibility',
                    'none');
                map.setLayoutProperty(
                    'detailLayer',
                    'visibility',
                    'visible');
            }
        }

    }

    const SetupMouseOver = (mapLocal) => {

        var popup = new mapboxgl.Popup({
            closeButton: false,
            closeOnClick: false,
            className: "removeMapBoxPopupPadding maxWidth600"
        });

        mapLocal.on('mouseenter', 'detailLayer', function (e) {
            // Change the cursor style as a UI indicator.
            mapLocal.getCanvas().style.cursor = 'pointer';
            var coordinates = e.features[0].geometry.coordinates.slice();
            var description = e.features[0].properties.description;
            var price = e.features[0].properties.price;
            var sqFt = e.features[0].properties.sqFt;
            var postCode = e.features[0].properties.postCode;

            var tblData = [["Postcode", postCode], ["Sqft", sqFt], ["bathrooms", e.features[0].properties.bathrooms], ["bedrooms", e.features[0].properties.bedrooms]];

            var dom = (<ThemeProvider theme={theme}>
                <Paper >
                    <Box p={1}>
                        <Typography variant="h6">{description}</Typography>
                        <Typography variant="subtitle1">£{price}</Typography>
                        <BasicTable data={tblData} />
                    </Box>
                </Paper>
            </ThemeProvider>)

            var placeholder = document.createElement('div')
            ReactDOM.render(dom, placeholder);

            // Ensure that if the map is zoomed out such that multiple
            // copies of the feature are visible, the popup appears
            // over the copy being pointed to.
            while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
                coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
            }

            // Populate the popup and set its coordinates
            // based on the feature found.
            //popup.setLngLat(coordinates).setHTML(html).addTo(mapLocal);
            popup.setLngLat(coordinates).setDOMContent(placeholder).addTo(mapLocal);
        });

        mapLocal.on('mouseenter', 'crimesLayer', function (e) {
            // Change the cursor style as a UI indicator.
            mapLocal.getCanvas().style.cursor = 'pointer';
            var coordinates = e.features[0].geometry.coordinates.slice();
            var crimetype = JSON.parse(e.features[0].properties.crimetypes);
            var month = e.features[0].properties.month;
            //TODO: redo this at indexer - cluster by lat long, and then by crimetype to give counts and date array. render as pie?
            var dataState = [];
            crimetype.forEach(a => dataState.push([a.name, a.totalCount,]));
            var placeholder = document.createElement('div')
            var tbl = (<ThemeProvider theme={theme}>
                <BasicTable data={dataState} />
            </ThemeProvider>)
            ReactDOM.render(tbl, placeholder);

            // Ensure that if the map is zoomed out such that multiple
            // copies of the feature are visible, the popup appears
            // over the copy being pointed to.
            while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
                coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
            }

            // Populate the popup and set its coordinates
            // based on the feature found.
            popup.setLngLat(coordinates).setDOMContent(placeholder).addTo(mapLocal);
        });

        //schools
        mapLocal.on('mouseenter', 'schoolsLayer', function (e) {
            // Change the cursor style as a UI indicator.
            mapLocal.getCanvas().style.cursor = 'pointer';

            mapLocal.setFeatureState({
                source: 'schoolCatchments',
                id: e.features[0].id
            }, {
                vis: 1
            });


            var coordinates = e.features[0].geometry.coordinates.slice();
            var name = e.features[0].properties.name;
            var offsted = e.features[0].properties.offsted;
            var schoolType = e.features[0].properties.schoolType;
            var structure = e.features[0].properties.structure;
            var capacity = e.features[0].properties.capcity;
            var size = e.features[0].properties.size;
            var sex = e.features[0].properties.sex;
            var denomination = e.features[0].properties.denomination;
            //TODO: redo this at indexer - cluster by lat long, and then by crimetype to give counts and date array. render as pie?
            //var html = `<h6>${name}</h6><p>Offsted: ${offsted}<br />`
            //if (schoolType != undefined) {
            //    html += `${schoolType} - ${structure}<br />`
            //}
            //else {
            //    html += `${structure}<br />`
            //}
            //html += `${capcity}% capacity (${size})<br />Gender: ${sex}<br />Denomination: ${denomination}</p>`
            var tblData = [["Offsted", offsted], ["Capacity", capacity], ["Size", size], ["Gender", sex], ["Denomination", denomination]];

            var dom = (<ThemeProvider theme={theme}>
                <Paper >
                    <Box p={1}>
                        <Typography variant="h6">{name}</Typography>
                        <Typography variant="p">{schoolType != undefined && schoolType + " - "}{structure}</Typography>
                        <BasicTable data={tblData} />
                    </Box>
                </Paper>
            </ThemeProvider>)

            var placeholder = document.createElement('div')
            ReactDOM.render(dom, placeholder);

            // Ensure that if the map is zoomed out such that multiple
            // copies of the feature are visible, the popup appears
            // over the copy being pointed to.
            while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
                coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
            }

            // Populate the popup and set its coordinates
            // based on the feature found.
            //popup.setLngLat(coordinates).setHTML(html).addTo(mapLocal);
            popup.setLngLat(coordinates).setDOMContent(placeholder).addTo(mapLocal);
        });

        mapLocal.on('click', 'detailLayer', function (e) {
            var f = e.features[0];
            setClicked(a => f.properties.id);
        });

        mapLocal.on('mouseleave', 'detailLayer', function () {
            mapLocal.getCanvas().style.cursor = '';
            popup.remove();
        });

        mapLocal.on('mouseleave', 'schoolsLayer', function (e) {
            var bbox = [
                [e.point.x - 20, e.point.y - 20],
                [e.point.x + 20, e.point.y + 20]
            ];
            var features = mapLocal.queryRenderedFeatures(bbox, {
                layers: ['schoolsLayer']
            });

            if (features.length == 0) {
                //failed to grab so remove ALL catchments.
                var x = mapLocal.querySourceFeatures('schoolCatchments');
                x.forEach(a => {
                    mapLocal.setFeatureState({
                        source: 'schoolCatchments',
                        id: a.id
                    }, {
                        vis: null
                    });
                });
            }
            else {
                features.forEach(a => {
                    mapLocal.setFeatureState({
                        source: 'schoolCatchments',
                        id: a.id
                    }, {
                        vis: null
                    });
                });
            }

            mapLocal.getCanvas().style.cursor = '';
            popup.remove();
        });

        mapLocal.on('mouseleave', 'crimesLayer', function () {
            mapLocal.getCanvas().style.cursor = '';
            popup.remove();
        });
    }


    const Add3d = (mapLocal) => {
        var layers = mapLocal.getStyle().layers;

        var labelLayerId;
        for (var i = 0; i < layers.length; i++) {
            if (layers[i].type === 'symbol' && layers[i].layout['text-field']) {
                labelLayerId = layers[i].id;
                break;
            }
        }

        mapLocal.addLayer(
            {
                'id': '3d-buildings',
                'source': 'composite',
                'source-layer': 'building',
                'filter': ['==', 'extrude', 'true'],
                'type': 'fill-extrusion',
                'minzoom': 12,
                'paint': {
                    'fill-extrusion-color': '#aaa',

                    // use an 'interpolate' expression to add a smooth transition effect to the
                    // buildings as the user zooms in
                    'fill-extrusion-height': [
                        'interpolate',
                        ['linear'],
                        ['zoom'],
                        13,
                        0,
                        13.1,
                        ['get', 'height']
                    ],
                    'fill-extrusion-base': [
                        'interpolate',
                        ['linear'],
                        ['zoom'],
                        13,
                        0,
                        13.1,
                        ['get', 'min_height']
                    ],
                    'fill-extrusion-opacity': 0.6
                }
            },
            labelLayerId
        );
    }

    useEffect(() => {
        const initMap = ({ setMap, mapContainer }) => {
            //mapbox://styles/housec84/ckqccqfbe03r718o40dwed8e0?optimize=true sat
            //mapbox://styles/housec84/ckouk806n1vxr17lkaic8078y?optimize=true street
            const mapLocal = new mapboxgl.Map({
                container: mapContainer.current,
                //style: 'mapbox://styles/mapbox/streets-v11',
                style: 'mapbox://styles/housec84/' + mapStyle.style,
                center: [lng, lat],
                zoom: zoom
            });

            mapLocal.on('style.load', function () {
                setStyleChange(a => !a);
                //if (data != null) {
                //    AddSources(map, data.data);
                //    AddLayers(map); //add custom layer and source to the new map style
                //}
            });

            mapLocal.on("load", () => {
                setMap(mapLocal);
                setBounds(mapLocal.getBounds());
                Add3d(mapLocal);
                mapLocal.loadImage(
                    'https://docs.mapbox.com/mapbox-gl-js/assets/custom_marker.png',
                    function (error, image) {
                        mapLocal.addImage('custom-marker', image);
                    });
                SetupMouseOver(mapLocal);
            });

            mapLocal.on('move', () => {

                setLng(mapLocal.getCenter().lng.toFixed(4));
                setLat(mapLocal.getCenter().lat.toFixed(4));
                setZoom(mapLocal.getZoom().toFixed(2));
                try {
                    let bounds = mapLocal.getBounds();
                    setBounds(bounds);
                }
                catch (err) {
                    console.log(err);
                }
            });
            mapLocal.scrollZoom.setWheelZoomRate(1 / 300); //default 1/450
            mapLocal.scrollZoom.setZoomRate(1 / 75); //default 1/100
        };

        if (!map) {
            initMap({ setMap, mapContainer });
        }

    }, [map]);


    //const debounce = (method, delayMs) => {
    //    delayMs = delayMs || 200;
    //    setTimer(null);
    //    clearTimeout(timer);
    //    var t = setTimeout(() => {
    //        method()
    //    }, delayMs);
    //    setTimer(t);
    //}

    return (
        <div className="map-container" ref={mapContainer} />
    );
};

export default MapBox;
